import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import toString from 'lodash/toString';
import { regExpValidationEmail, reqExpNumber } from '@yme/utils/regEx';
export const validation = (value, config, cb) => {
    let errors = [];
    forEach(config?.errors, (error) => {
        if (error === 'required') {
            errors = isEmpty(toString(value)) ? ['required'] : [];
        }
        if (error === 'regexp') {
            const pattern = regExpValidationEmail;
            if (cb) {
                errors = [...errors, ...cb(value)];
            }
            else {
                errors = pattern.test(toString(value)) ? errors : [...errors, 'regexp'];
            }
        }
        if (error === 'number') {
            const pattern = reqExpNumber;
            if (cb) {
                errors = [...errors, ...cb(value)];
            }
            else {
                errors = pattern.test(toString(value)) ? errors : [...errors, 'number'];
            }
        }
    });
    return errors;
};
